var _clipPath, _clipPath2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg12537",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs12541"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(657.75037,0,0,-657.75037,175.9175,256)",
    spreadMethod: "pad",
    id: "linearGradient12563"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffeadb"
    },
    offset: 0,
    id: "stop12557"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffeadb"
    },
    offset: 0.00070112,
    id: "stop12559"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e0cdf5"
    },
    offset: 1,
    id: "stop12561"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12573"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path12571"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12581"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.0018,421.944 H 456.002 V 137.694 H 56.0018 Z",
    id: "path12579"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g12543",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12555"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 353.137,383.157 c -11.479,-7.405 -25.38,-9.887 -38.716,-6.926 v 0 c -31.565,7.008 -64.584,2.221 -92.707,-13.042 v 0 c -18.907,-10.261 -41.936,-8.477 -59.579,3.829 v 0 c -11.713,8.169 -25.313,14.023 -40.258,16.778 v 0 C 66.44,394.012 12.541,357.242 1.884,301.888 v 0 C -9.014,245.28 28.512,190.876 85.08,180.799 v 0 c 13.821,-2.462 27.488,-2.046 40.388,0.816 v 0 c 20.936,4.645 42.81,-3.122 56.321,-19.776 v 0 c 8.528,-10.512 18.812,-19.895 30.757,-27.689 v 0 c 61.731,-40.279 144.427,-22.89 184.707,38.841 v 0 c 0.043,0.066 0.085,0.131 0.128,0.197 v 0 c 7.377,11.348 18.851,19.439 32.12,22.117 v 0 c 19.352,3.908 37.801,13.405 52.755,28.496 v 0 c 19.834,20.014 29.76,46.346 29.744,72.681 v 0 0.037 c -0.025,25.932 -9.691,51.865 -29.031,71.76 v 0 c -20.267,20.849 -47.131,31.274 -73.987,31.276 v 0 c -19.452,0.002 -38.895,-5.464 -55.845,-16.398",
    style: {
      fill: "url(#linearGradient12563)",
      stroke: "none"
    },
    id: "path12565"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g12567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12569",
    clipPath: "url(#clipPath12573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12575"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12589"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath12581)",
    opacity: 0.100006,
    id: "g12587"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(456.002,406.9443)",
    id: "g12585"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -254.25 c 0,-8.28 -6.72,-15 -15,-15 h -370 c -8.28,0 -15,6.72 -15,15 V 0 c 0,8.279 6.72,15 15,15 H -15 C -6.72,15 0,8.279 0,0",
    style: {
      fill: "#2626bc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12583"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g12591",
    transform: "translate(312.7114,43.9873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -113.42 l 22.681,89.904 h 68.057 z",
    style: {
      fill: "#9fb0fe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12595",
    transform: "translate(297.9297,102.5898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -83.856 l 7.899,31.302 H -7.9 Z",
    style: {
      fill: "#8399fe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12597"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12599",
    transform: "translate(455.998,385.9443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -254.25 c 0,-8.28 -6.72,-15 -15,-15 h -370 c -8.28,0 -15,6.72 -15,15 V 0 c 0,8.28 6.72,15 15,15 H -15 C -6.72,15 0,8.28 0,0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12601"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12603",
    transform: "translate(440.998,400.9443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -68.72 V -284.25 H 0 c 8.28,0 15,6.72 15,15 V -15 C 15,-6.72 8.28,0 0,0",
    style: {
      fill: "#ffc4df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12605"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12607",
    transform: "translate(256.002,313.4502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -86,-72.633 h 20 c 1.657,0 3,-1.344 3,-3 v -79.851 H 63 v 79.851 c 0,1.656 1.343,3 3,3 h 20 z",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12609"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12611",
    transform: "translate(342.002,240.8174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -86,72.633 -172,0",
    style: {
      fill: "none",
      stroke: "#ff7eb8",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12613"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12615",
    transform: "translate(260.335,157.9658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -42 v 67.665 c 0,2.762 2.239,5 5,5 h 32 c 2.762,0 5,-2.238 5,-5 z",
    style: {
      fill: "#6583fe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12619",
    transform: "translate(297.9297,217.9639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-6.995 -5.671,-12.666 -12.667,-12.666 -6.996,0 -12.666,5.671 -12.666,12.666 0,6.996 5.67,12.667 12.666,12.667 C -5.671,12.667 0,6.996 0,0",
    style: {
      fill: "#ffeadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12621"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12623",
    transform: "translate(456.002,352.7695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 33.171 c 0,8.285 -6.716,15 -15,15 h -370 c -8.284,0 -15,-6.715 -15,-15 V 0 Z",
    style: {
      fill: "#6583fe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12627",
    transform: "translate(83.5425,352.7695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 372.459",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12631",
    transform: "translate(312.7114,43.9873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -113.42 l 22.681,89.904 h 68.057 z",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12633"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12635",
    transform: "translate(56.002,167.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -35.39 c 0,-8.284 6.716,-15 15,-15 h 370 c 8.284,0 15,6.716 15,15 V 0 Z",
    style: {
      fill: "#b7c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12637"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12639",
    transform: "translate(455.4492,167.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -399.447",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12641"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12643",
    transform: "translate(180.0679,43.9922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 151.868",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12645"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12647",
    transform: "translate(94.084,376.9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -0.146",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12649"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12651",
    transform: "translate(113.4087,376.9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -0.146",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12653"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12655",
    transform: "translate(132.7334,376.9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -0.146",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12659",
    transform: "translate(363.0483,116.6934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 77.954 c 8.284,0 15,6.716 15,15 v 254.247 c 0,8.285 -6.716,15 -15,15 h -370 c -8.285,0 -15,-6.715 -15,-15 V 15 c 0,-8.284 6.715,-15 15,-15 h 264.505",
    style: {
      fill: "none",
      stroke: "#2626bc",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12661"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12663",
    transform: "translate(124.2949,292.7373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.242 -5.007,5.008 0,2.764 2.241,5.007 5.007,5.007 H 0 c 2.766,0 5.007,-2.243 5.007,-5.007 C 5.007,2.242 2.766,0 0,0",
    style: {
      fill: "#b7c5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12665"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12667",
    transform: "translate(429.2949,257.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.242 -5.007,5.007 0,2.765 2.241,5.008 5.007,5.008 H 0 c 2.766,0 5.007,-2.243 5.007,-5.008 C 5.007,2.242 2.766,0 0,0",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12669"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12671",
    transform: "translate(429.2949,235.8105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.241 -5.007,5.007 0,2.764 2.241,5.007 5.007,5.007 H 0 c 2.766,0 5.007,-2.243 5.007,-5.007 C 5.007,2.241 2.766,0 0,0",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12673"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12675",
    transform: "translate(429.2949,214.4531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.242 -5.007,5.007 0,2.765 2.241,5.008 5.007,5.008 H 0 c 2.766,0 5.007,-2.243 5.007,-5.008 C 5.007,2.242 2.766,0 0,0",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12679",
    transform: "translate(166.2949,319.5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -76.586 c -2.766,0 -5.007,2.241 -5.007,5.007 0,2.764 2.241,5.007 5.007,5.007 H 0 c 2.766,0 5.007,-2.243 5.007,-5.007 C 5.007,2.241 2.766,0 0,0",
    style: {
      fill: "#02ffb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12681"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12683",
    transform: "translate(124.2949,274.9521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.242 -5.007,5.008 0,2.764 2.241,5.007 5.007,5.007 H 0 c 2.766,0 5.007,-2.243 5.007,-5.007 C 5.007,2.242 2.766,0 0,0",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12685"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12687",
    transform: "translate(124.2949,257.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -34.586 c -2.766,0 -5.007,2.242 -5.007,5.007 0,2.765 2.241,5.008 5.007,5.008 H 0 c 2.766,0 5.007,-2.243 5.007,-5.008 C 5.007,2.242 2.766,0 0,0",
    style: {
      fill: "#ffa8cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12691",
    transform: "translate(395.1753,319.7012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.094,0 -5.603,2.509 -5.603,5.604 0,3.093 2.509,5.602 5.603,5.602 3.094,0 5.603,-2.509 5.603,-5.602 C 5.603,2.509 3.094,0 0,0",
    style: {
      fill: "#ff7eb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12693"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12695",
    transform: "translate(395.1753,299.752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.094,0 -5.603,2.509 -5.603,5.603 0,3.094 2.509,5.603 5.603,5.603 3.094,0 5.603,-2.509 5.603,-5.603 C 5.603,2.509 3.094,0 0,0",
    style: {
      fill: "#ff7eb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12697"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12699",
    transform: "translate(395.1753,279.8027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.094,0 -5.603,2.508 -5.603,5.603 0,3.094 2.509,5.602 5.603,5.602 3.094,0 5.603,-2.508 5.603,-5.602 C 5.603,2.508 3.094,0 0,0",
    style: {
      fill: "#ff7eb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12701"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12703",
    transform: "translate(113.4087,219.4883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-6.413 -5.2,-11.613 -11.613,-11.613 -6.414,0 -11.614,5.2 -11.614,11.613 0,6.414 5.2,11.613 11.614,11.613 C -5.2,11.613 0,6.414 0,0 Z",
    style: {
      fill: "none",
      stroke: "#6583fe",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12705"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12707",
    transform: "translate(90.1821,196.2617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,6.414 5.199,11.613 11.613,11.613 18.027,11.613 23.227,6.414 23.227,0",
    style: {
      fill: "none",
      stroke: "#6583fe",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12709"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12711",
    transform: "translate(400.7783,468.0127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-6.083 -4.932,-11.016 -11.016,-11.016 -4.932,-11.016 0,-15.947 0,-22.031 0,-15.947 4.932,-11.016 11.016,-11.016 4.932,-11.016 0,-6.083 0,0 Z",
    style: {
      fill: "none",
      stroke: "#97ffd2",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12713"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12715",
    transform: "translate(165.4448,98.0068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-6.084 -4.932,-11.016 -11.016,-11.016 -4.932,-11.016 0,-15.947 0,-22.031 0,-15.947 4.932,-11.016 11.016,-11.016 4.932,-11.016 0,-6.084 0,0 Z",
    style: {
      fill: "none",
      stroke: "#6583fe",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12719",
    transform: "translate(107.002,83.3291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-6.084 -4.932,-11.016 -11.016,-11.016 -4.932,-11.016 0,-15.948 0,-22.031 0,-15.948 4.932,-11.016 11.016,-11.016 4.932,-11.016 0,-6.084 0,0 Z",
    style: {
      fill: "none",
      stroke: "#6583fe",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12721"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12723",
    transform: "translate(346.2842,433.0078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -10.994,10.994 0,21.988 10.994,10.994 Z",
    style: {
      fill: "none",
      stroke: "#ff7eb8",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12725"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f0b291f9375f910dde17c013202a77c5.svg";
export { ForwardRef as ReactComponent };